// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

function handleInternalDeereCommentsChange(event) {

    this.onInternalDeereCommentsChange(event.target.value);

}

function handleCommentsToDealerChange(event) {

    this.onCommentsToDealerChange(event.target.value);

}

function handleConfirmation() {

    this.onConfirmation(this.machineStatusModalAction, this.machineStatusItemToUpdate);

}

const MachineUpdateModalBody = props =>
    <section className='machine-update-modal-body'>
        <div className='row'>
            <LabeledString
                className='pin'
                data={props.machineStatusItemToUpdate.product.pin}
                label='PIN'
            />
        </div>
        <div className='row'>
            <span className='data-label internal-deere-comments'>
                <FormattedMessage id='INTERNAL_DEERE_COMMENTS'/>
            </span>
            <textarea
                maxLength='120'
                onChange={props::handleInternalDeereCommentsChange}
            >
            </textarea>
        </div>
        <div className='row'>
            <span className='data-label comments-to-dealer'>
                <FormattedMessage id='COMMENTS_TO_DEALER'/>
            </span>
            <textarea
                maxLength='120'
                onChange={props::handleCommentsToDealerChange}
            >
            </textarea>
        </div>
        <div className='button'>
            <button
                className='primary'
                onClick={props::handleConfirmation}
            >
                <FormattedMessage id='CONFIRM'/>
            </button>
        </div>
    </section>;

MachineUpdateModalBody.displayName = 'MachineUpdateModalBody';
MachineUpdateModalBody.propTypes = {
    machineStatusItemToUpdate: PropTypes.instanceOf(StatusChange).isRequired,
    machineStatusModalAction: PropTypes.string.isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default MachineUpdateModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/machine-update-modal-body.js